import { render, staticRenderFns } from "./ManagerComments.vue?vue&type=template&id=709f5e5a&scoped=true&"
import script from "./ManagerComments.vue?vue&type=script&lang=js&"
export * from "./ManagerComments.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-comments.scss?vue&type=style&index=0&id=709f5e5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f5e5a",
  null
  
)

export default component.exports